import {CommonStatus} from "@/enums/status";

export class PostOfficeParams {
    page? = 1;
    limit? = 10;
    search?: string;
    status? = CommonStatus.Active;
}
